export default __webpack_public_path__ + "static/media/illus07.6a7148ad.png";